// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"fill-color"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.9999 21.4853L20.4852 13H3.51465L11.9999 21.4853Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11.9999 4.51491L20.4852 13.0002L11.9999 21.4855L3.51465 13.0002L11.9999 4.51491ZM11.9999 4.51491L9.52506 2.04004M19.9499 13H4.24991","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20.2197 21.0095C20.5126 21.3795 20.9874 21.3795 21.2803 21.0095C21.5732 20.6396 21.5732 20.0398 21.2803 19.6698L20.75 19L20.2197 19.6698C19.9268 20.0398 19.9268 20.6396 20.2197 21.0095Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-fill-color')
export default class FillColorIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fill-color',
    }
  }
}
